<template>
  <div>
    <main-layout :ResizeCallback="resize">
      <div class="tabContainer">
        <div id="vizContainer" ref="vizContainer" v-bind:style="{'height': this.reportHeight+'px','min-height':this.reportMinHeight+'px','overflow-x':'auto', 'overflow-y':'hidden'}"></div>
      </div>
    </main-layout>
  </div>
</template>
<style scoped>
  .tabContainer {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: 1280px;
  }
</style>
<script>
import MainLayout from "../components/MainLayout.vue";
import config from "../../config";
import tableau from "tableau-api";
import * as api from "../api";

export default {
  data() {
    return {
      tableau_viz: {},
      tableau_toolbar_width:0,
      tableau_toolbar_visible: "hidden",
	    reportHeight: this.getSize(),
      reportMinHeight: this.getSize()
    };
  },
  created: function() {
    document.body.scrollTop = 0;
  },
  methods: {
    getSize: function() {
      return window.innerHeight - 165;
    },
    resize: function() {
      let height = this.getSize();
      this.reportHeight = height <= 250 ? 250 : height;
    }
  },
  mounted: function() {
    let _self = this;
    if (this.$store.state.accessToken !== "") {
      let path = this.$store.state.route.query.path;
      if (_self.$store.state.isTableauLogin){
          let trustedUrl = config.get("TableauServer") + '/' + path
          var options = {
            usePublishedSize: true,
            toolbarPosition: "top",
            hideToolbar: false,
            onFirstVizSizeKnown: function (e) {
                if(e.$vizSize.sheetSize.maxSize != undefined && e.$vizSize.sheetSize.maxSize.width != 0){
                    _self.tableau_toolbar_width =  e.$vizSize.sheetSize.maxSize.width
                }
                
            }
          };
          _self.tableau_viz = new tableau.Viz(
            this.$refs.vizContainer,
            trustedUrl,
            options
          );
          _self.tableau_viz.addEventListener("customviewload", function() {
            _self.tableau_toolbar_visible = "visible"
            _self.$store.commit("tableau_login");
            if(_self.tableau_viz._impl.$vizSize.sheetSize.minSize){
              _self.reportMinHeight = _self.tableau_viz._impl.$vizSize.sheetSize.minSize.height + 18;
            }
          });
      }
    }
  },
  components: {
    MainLayout
  }
};
</script>


// WEBPACK FOOTER //
// Tableau.vue?50084dae